import { CustomOrderImportSchemaSchema } from "@redotech/redo-fulfillment-common/import-schema";
import * as z from "zod";

export const getCustomImportSchemas = {
  name: "getCustomImportSchemas" as const,
  input: z.object({}),
  output: z.object({ schemas: z.array(CustomOrderImportSchemaSchema) }),
};
